import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';

const CategoryFilter = ({ categories, counts, selected, onChange }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.startsWith('zh') ? 'zh' : 'en';

  return (
    <div
      className={styles.categoryFilter}
      role="group"
      aria-label={t('tools.categoryLabel', lang === 'zh' ? '工具分类' : 'Tool categories')}
    >
      {categories
        .filter((category) => counts[category.key] > 0)
        .map((category) => {
          const isActive = selected === category.key;
          return (
            <button
              key={category.key}
              type="button"
              className={`${styles.categoryTab} ${isActive ? styles.active : ''}`}
              aria-pressed={isActive}
              onClick={() => onChange(category.key)}
            >
              <span className={styles.label}>{category.label[lang]}</span>
              <span className={styles.count} aria-hidden="true">
                {counts[category.key]}
              </span>
            </button>
          );
        })}
    </div>
  );
};

export default CategoryFilter;
